/**
 * Smart Start – Phone Number Validation (NANP only)
 * Validates US/Canada phone numbers on all marketing websites.
 * Self-contained IIFE; no external dependencies, no API calls.
 */
(function () {
  'use strict';

  /**
   * Built-in fallback translations keyed by ISO 639-1 language code.
   * PHP injects window.globalIIDPhoneValidation.i18n via wp_localize_script().
   */
  var GLOBAL_IID_PHONE_I18N = {
    en: {
      invalid:    'Please enter a valid 10-digit phone number.',
      fieldLabel: 'Phone'
    },
    fr: {
      invalid:    'Veuillez entrer un numéro de téléphone à 10 chiffres valide.',
      fieldLabel: 'Téléphone'
    },
    es: {
      invalid:    'Por favor, ingrese un número de teléfono válido de 10 dígitos.',
      fieldLabel: 'Teléfono'
    }
  };

  function globalIIDGetI18n() {
    if (window.globalIIDPhoneValidation && window.globalIIDPhoneValidation.i18n) {
      return window.globalIIDPhoneValidation.i18n;
    }
    var lang = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
    return GLOBAL_IID_PHONE_I18N[lang] || GLOBAL_IID_PHONE_I18N['en'];
  }

  /**
   * NANP validation only (US/Canada).
   * Accepts 10 digits, or 11 digits with a leading 1 (country code).
   * Area code (digit 0) and exchange (digit 3) cannot start with 0 or 1.
   */
  function globalIIDIsValidPhone(rawValue) {
    var digits = rawValue.replace(/\D/g, '');

    // Strip leading country code 1 when 11 digits are present.
    if (digits.length === 11 && digits[0] === '1') {
      digits = digits.slice(1);
    }

    if (digits.length !== 10) return false;
    if (digits[0] === '0' || digits[0] === '1') return false;
    if (digits[3] === '0' || digits[3] === '1') return false;

    return true;
  }

  /**
   * Injects a <style> tag that hides the intl-tel-input flag container
   * and removes the extra left padding it leaves on the input.
   */
  function globalIIDHidePhoneFlags() {
    if (document.getElementById('ss-hide-phone-flags')) return;
    var style = document.createElement('style');
    style.id = 'ss-hide-phone-flags';
    style.textContent =
      '.iti__flag-container, .iti__selected-flag, .iti__flag, .iti__country-container { display: none !important; }' +
      '.iti input[type="tel"], .iti--allow-dropdown input[type="tel"], .iti--separate-dial-code input[type="tel"] { padding-left: 8px !important; }';
    document.head.appendChild(style);
  }

  function globalIIDForEach(list, callback) {
    for (var i = 0; i < list.length; i++) {
      callback(list[i], i);
    }
  }

  function globalIIDShowPhoneError(input, message) {
    var gfield = input.closest ? input.closest('.gfield') : null;
    if (!gfield) return;

    var existingError = gfield.querySelector('.ss-phone-error');
    if (existingError) {
      existingError.textContent = message;
      gfield.classList.add('gfield_error');
      return;
    }

    var errorEl = document.createElement('span');
    errorEl.className = 'ss-phone-error gfield_description validation_message gfield_validation_message';
    errorEl.setAttribute('role', 'alert');
    errorEl.textContent = message;

    var inputContainer = gfield.querySelector('.ginput_container') || gfield;
    inputContainer.appendChild(errorEl);
    gfield.classList.add('gfield_error');
  }

  function globalIIDClearPhoneError(input) {
    var gfield = input.closest ? input.closest('.gfield') : null;
    if (!gfield) return;

    var existingError = gfield.querySelector('.ss-phone-error');
    if (existingError) existingError.parentNode.removeChild(existingError);

    var gfMessages = gfield.querySelectorAll('.gfield_description.validation_message');
    globalIIDForEach(gfMessages, function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });

    gfield.classList.remove('gfield_error');
  }

  function globalIIDGetActivePage(form) {
    var activePage = form.querySelector(
      '.gform_page:not([style*="display: none"]):not([style*="display:none"])'
    );
    return activePage || form;
  }

  /**
   * Validates all phone inputs on the active page of a form.
   * Returns true when every phone field passes.
   */
  function globalIIDValidateFormPhones(form) {
    var activePage = globalIIDGetActivePage(form);
    var phoneInputs = activePage.querySelectorAll('input[type="tel"]');
    var allValid = true;

    globalIIDForEach(phoneInputs, function (input) {
      var rawValue = input.value.trim();

      // Empty fields are skipped; Gravity Forms handles required validation.
      if (!rawValue || !/[0-9]/.test(rawValue)) {
        globalIIDClearPhoneError(input);
        return;
      }

      if (!globalIIDIsValidPhone(rawValue)) {
        globalIIDShowPhoneError(input, globalIIDGetI18n().invalid);
        allValid = false;
      } else {
        globalIIDClearPhoneError(input);
      }
    });

    return allValid;
  }

  function globalIIDInitPhoneValidation() {
    var forms = document.querySelectorAll('.gform_wrapper form');

    globalIIDForEach(forms, function (form) {
      var activePage = globalIIDGetActivePage(form);
      globalIIDForEach(activePage.querySelectorAll('input[type="tel"]'), function (input) {
        if (input.dataset.globalIIDPhoneValidationBound) return;
        input.dataset.globalIIDPhoneValidationBound = '1';

        input.addEventListener('blur', function () {
          var rawValue = input.value.trim();
          if (!rawValue || !/[0-9]/.test(rawValue)) {
            globalIIDClearPhoneError(input);
            return;
          }
          if (!globalIIDIsValidPhone(rawValue)) {
            globalIIDShowPhoneError(input, globalIIDGetI18n().invalid);
          } else {
            globalIIDClearPhoneError(input);
          }
        });
      });

      if (!form.dataset.globalIIDSubmitBound) {
        form.dataset.globalIIDSubmitBound = '1';
        form.addEventListener('submit', function (e) {
          if (!globalIIDValidateFormPhones(form)) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        }, true);
      }

      var nextBtns = form.querySelectorAll('.gform_next_button, [id^="gform_next_button"]');
      globalIIDForEach(nextBtns, function (btn) {
        if (btn.dataset.globalIIDNextClickBound) return;
        btn.dataset.globalIIDNextClickBound = '1';
        btn.addEventListener('click', function (e) {
          if (!globalIIDValidateFormPhones(form)) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        }, true);
      });
    });
  }

  // Block GF "Next" button via pointerdown (catches Swiper slides too).
  window.addEventListener('pointerdown', function (event) {
    var btn = event.target && event.target.closest
      ? event.target.closest('.gform_next_button, [id^="gform_next_button"]')
      : null;
    if (!btn) return;
    var form = btn.closest('form');
    if (!form) return;
    if (!globalIIDValidateFormPhones(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  function globalIIDHookSwiper() {
    var selectors = ['.swiper', '.swiper-container', '.gform_page_wrapper', '.gform-body', '.gform_wrapper'];
    var swiper = null;
    for (var si = 0; si < selectors.length; si++) {
      var els = document.querySelectorAll(selectors[si]);
      for (var ei = 0; ei < els.length; ei++) {
        if (els[ei].swiper) { swiper = els[ei].swiper; break; }
      }
      if (swiper) break;
    }
    if (!swiper || swiper._ssValidationHooked) return !!swiper;
    swiper._ssValidationHooked = true;

    var origSlideNext = swiper.slideNext.bind(swiper);
    swiper.slideNext = function (speed, runCallbacks, internal) {
      var form = document.querySelector('.gform_wrapper form');
      if (form && !globalIIDValidateFormPhones(form)) return;
      return origSlideNext(speed, runCallbacks, internal);
    };

    var origSlideTo = swiper.slideTo.bind(swiper);
    swiper.slideTo = function (index, speed, runCallbacks) {
      if (typeof index === 'number' && index > swiper.activeIndex) {
        var form = document.querySelector('.gform_wrapper form');
        if (form && !globalIIDValidateFormPhones(form)) return;
      }
      return origSlideTo(index, speed, runCallbacks);
    };

    return true;
  }

  function globalIIDTryHookSwiper(attempts) {
    if (globalIIDHookSwiper()) return;
    if ((attempts || 0) < 15) {
      setTimeout(function () { globalIIDTryHookSwiper((attempts || 0) + 1); }, 200);
    }
  }

  function globalIIDInit() {
    globalIIDHidePhoneFlags();
    globalIIDInitPhoneValidation();
    globalIIDTryHookSwiper();
  }

  document.addEventListener('DOMContentLoaded', globalIIDInit);
  document.addEventListener('gform_page_loaded', function () {
    globalIIDHidePhoneFlags();
    globalIIDInitPhoneValidation();
  });

  if (window.jQuery) {
    window.jQuery(document).on('gform_post_render gform_page_loaded', globalIIDInit);
  }

})();
